module.exports = __webpack_public_path__ + "img/menuPresentation.7689686e.svg";